import React, {PureComponent} from 'react';
import {Trans} from 'react-i18next'

const faqList = [
    {
        question: 'What\'s the difference between transcription and captions?',
        answer: 'text01',
    },
    {
        question: 'Tell me about your confidentiality policy.',
        answer: 'text02',
    },
    {
        question: 'What\'s the difference between transcription and captions?',
        answer: 'text03',
    },
    {
        question: 'What\'s the difference between transcription and captions?',
        answer: 'text04',
    },
    {
        question: 'What\'s the difference between transcription and captions?',
        answer: 'text05',
    },
];

class Faq extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            currentQuestion: -1,
            isOpenFullList: false,
        }
    }

    openQuestionClick = i => {
        this.setState({
            currentQuestion: i !== this.state.currentQuestion ? i : -1
        });
    };

    showMoreClick = () => this.setState({isOpenFullList: !this.state.isOpenFullList})

    render() {
        const {currentQuestion, isOpenFullList} = this.state;
        const list = isOpenFullList ? faqList : faqList.slice(0, 2);

        return <div className="box mobile-hidden">
            <div className="title-holder">
                <span className="title"><Trans>FAQ</Trans></span>
            </div>
            <dl className="faq-area">
                {list.map((faq, i) => (
                    <span key={i} onClick={() => {this.openQuestionClick(i)}} className={i === currentQuestion ? 'active' : ''}>
                        <dt>{faq.question}</dt>
                        <dd>{faq.answer}</dd>
                    </span>
                ))}
            </dl>
            <div className="aligncenter">
                <a className={`link-more ${isOpenFullList ? 'active' : ''}`} onClick={this.showMoreClick}>
                    <Trans>{isOpenFullList ? 'show less' : 'show more'}</Trans>
                </a>
            </div>
        </div>
    }
}

export default Faq